<template>
  <div class="row justify-content-center">
    <div class="col-xl-10 col-lg-10 col-md-12">
      <card class="card" :title="$t('bankBilling.title')">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-6 col-12 mb-3">
            <fg-input
              type="text"
              :label="$t('bankBilling.bankNameType')"
              :placeholder="$t('bankBilling.bankNamePlaceholder')"
              v-model="account_type"
            >
            </fg-input>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-12 mb-3">
            <fg-input
              type="text"
              :label="$t('bankBilling.accountHolder')"
              :placeholder="$t('bankBilling.accountHolderPlaceholder')"
              v-model="account_holder_name"
            >
            </fg-input>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-8 col-12 mb-3">
            <fg-input
              type="text"
              :label="$t('bankBilling.ibanAddress')"
              :placeholder="$t('bankBilling.ibanPlaceholder')"
              v-model="iban"
            >
            </fg-input>
          </div>
          <div class="col-xl-1 col-lg-1 col-md-4 col-12 d-flex align-items-center justify-content-center mb-3">
            <p-button
              type="info"
              round
              @click.native.prevent="addBank"
              :class="editing_index != null ? 'ti-save' : 'ti-plus'"
            ></p-button>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <card class="card-plain">
              <table class="table table-striped b-table-fixed tableClass">
                <thead>
                <tr>
                  <th>{{ $t('bankBilling.bankType') }}</th>
                  <th>{{ $t('bankBilling.accountHolder') }}</th>
                  <th>{{ $t('bankBilling.iban') }}</th>
                  <th>{{ $t('bankBilling.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in bank_info.banks" :key="index">
                  <td>{{ item.account_type }}</td>
                  <td>{{ item.account_holder_name }}</td>
                  <td>{{ item.iban }}</td>
                  <td>
                    <p-button
                      type="info"
                      round
                      @click.native.prevent="editBank(index)"
                      class="text-center ti-pencil-alt"
                    ></p-button>
                    <p-button
                      type="danger"
                      round
                      @click.native.prevent="removeBank(index)"
                      class="text-center ti-trash"
                    ></p-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </card>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>{{ $t('bankBilling.billingInfo') }}</label>
              <textarea
                rows="5"
                class="form-control border-input"
                :placeholder="$t('bankBilling.billingPlaceholder')"
                v-model="bank_info.billing"
              >
              </textarea>
            </div>
          </div>
        </div>
        <div class="text-center">
          <p-button type="info" round @click.native.prevent="updateBank">
            {{ $t('bankBilling.update') }}
          </p-button>
        </div>
        <div class="clearfix"></div>
      </card>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import config from "@/routing_map.json";
import router from "@/router";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import {PaperTable} from "@/components";

export default {
  components: {
    PaperTable,
  },
  data() {
    return {
      bank_info: {
        banks: [],
        billing: null,
      },
      table_columns: ["account_type", "bank_name", "Iban"],
      account_type: null,
      account_holder_name: null,
      iban: null,
      editing_index: null,
    }
  },

  mounted() {
    this.getUser()
  },
  methods: {
    updateBank() {
      const app_data = this;
      axios.defaults.headers.common.authorization = localStorage.getItem('authorization');
      axios.post(
        `${config.app_url}/user/update-user-bank`,
        app_data.bank_info
      ).then(response => {
        if (response.data.success) {
          app_data.notifyVue('top', 'right', "Güncelleme Başarılı!", "success");
        } else {
          app_data.notifyVue('top', 'right', "Güncelleme Başarısız!", "warning");
        }
      }).catch(error => {
        app_data.notifyVue('top', 'right', "Bağlantı Hatası!", "warning");
      });
    },
    getUser() {
      const app_data = this;
      axios.defaults.headers.common.authorization = localStorage.getItem('authorization');
      axios.get(
        `${config.app_url}/user/get-user`,
      ).then(response => {
        if (response.data.success) {
          if (response.data.msg.bank_info) app_data.bank_info = response.data.msg.bank_info;
        } else {

        }
      }).catch(error => {
        router.push('login');
        app_data.$toast.error(error.toString());
      });
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: NotificationTemplate,
        title: message,
        icon: "info",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
        duration: 2000
      });
    },
    addBank() {
      if (this.editing_index != null ) {
        this.bank_info.banks[parseInt(this.editing_index)].account_type = this.account_type;
        this.bank_info.banks[parseInt(this.editing_index)].account_holder_name = this.account_holder_name;
        this.bank_info.banks[parseInt(this.editing_index)].iban = this.iban;
        this.editing_index = null;
      } else {
        this.bank_info.banks.push({
          account_type: this.account_type,
          account_holder_name: this.account_holder_name,
          iban: this.iban
        });
      }

      this.account_holder_name = null;
      this.iban = null;
      this.account_type = null;
    },
    editBank(index) {
      this.editing_index = index;
      this.account_holder_name = this.bank_info.banks[index].account_holder_name;
      this.iban = this.bank_info.banks[index].iban;
      this.account_type = this.bank_info.banks[index].account_type;
    },
    removeBank(index) {
      this.bank_info.banks.splice(index, 1);
    },

  },
};
</script>

<style scoped>
.tableClass {
  width: 100%;
  overflow-x: auto;
}

textarea {
  width: 100%;
}

.card {
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .row {
    margin: 0;
  }

  .col-xl-3, .col-xl-4, .col-md-4, .col-md-6, .col-md-8, .col-12 {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 10px;
  }

  .p-button {
    margin-top: 10px;
    width: 100%;
  }

  .card-body {
    padding: 15px;
  }

  .tableClass {
    font-size: 12px;
  }

  .form-group {
    margin-bottom: 10px;
  }
}
</style>
